import React, { useState, useEffect } from 'react';
import {
  IonContent,
  IonPage,
  IonRefresher,
  IonRefresherContent,
  IonGrid,
  IonRow,
  IonCard,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonIcon,
  IonSearchbar,
  IonSkeletonText,
  IonCardHeader,
  IonCardTitle,
} from '@ionic/react';
import { useTranslation } from 'react-i18next';
import axios from '../../axios';
import { RefresherEventDetail } from '@ionic/core';
import { chevronDownCircleOutline, location } from 'ionicons/icons';
import Header from '../../components/Header';
import { Link } from 'react-router-dom';
import { useContext } from 'react';
import { AppContext } from '../../providers/AppContext';
import NoRecords from '../../components/NoRecords';
import Red from '../../assets/Red.svg';

const ViewAllProjects: React.FC = () => {
  const [data, setData] = useState({
    dataSet: [],
    loading: false,
  });
  const { t } = useTranslation();

  const { state } = useContext(AppContext);

  const [isLoading, setIsLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(0);

  const [searchText, setSearchText] = useState('');
  const [filter] = useState<string>();

  const [disableInfiniteScroll, setDisableInfiniteScroll] = useState<boolean>(false);

  const getData = (context: any) => {
    let url = `method/preflet_asset.apis.project.routes.project_list?limit=${state.maxLength}&start=${context?.isFiltered ? 0 : currentPage * 10 + 0
      }`;
     
    // add search data if any
    if ('search' in context || searchText) {
      setSearchText(context?.search || '');
      if (context.search) url += `&search=${context.search || searchText}`;
    }
    setIsLoading(true);

    var config: any = {
      method: 'get',
      url,
      headers: {
        Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
      },
    };
    axios(config)
      .then((res: any) => {
        if (res && res?.data?.data && res?.data?.data?.length > 0) {
          if (context.isFiltered) {
            const rawData = { dataSet: [], loading: false };
            rawData.dataSet = res.data.data;
            setData(rawData);
          } else {
            const rawData = { ...data };
            // @ts-ignore
            rawData.dataSet.push(...res?.data?.data);
            setData(rawData);
          }
          setDisableInfiniteScroll(res.data.data.length < state.maxLength);
        } else {
          const value = { ...data };
          setData(value);
          setDisableInfiniteScroll(true);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
        setCurrentPage(currentPage + 1);
      });
  };

  useEffect(() => {
    getData({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function doRefresh(event: CustomEvent<RefresherEventDetail>) {
    getData({});
    setTimeout(() => {
      event.detail.complete();
    }, 2000);
  }

  async function searchNext($event: CustomEvent<void>) {
    getData({});
    ($event.target as HTMLIonInfiniteScrollElement).complete();
  }



  const handleSearch = (value: any) => {
    getData({ search: value, isFiltered: true });
  }

  return (
    <IonPage>
      <Header enableBackButton='goBack' title={t('Project.projectsList')} />
      <IonSearchbar
        className="data-list"
        value={searchText}
        // @ts-ignore
        onIonChange={(e) => handleSearch(e.detail.value!)}
      ></IonSearchbar>

      <IonContent>
        <IonRefresher slot="fixed" onIonRefresh={doRefresh}>
          <IonRefresherContent
            pullingIcon={chevronDownCircleOutline}
            pullingText={t('Utils.pullRefresh')}
            refreshingSpinner="circles"
            refreshingText={t('Utils.refreshing')}
          ></IonRefresherContent>
        </IonRefresher>

        {isLoading && data.dataSet.length ?
          [1, 2, 3, 4, 5, 6, 7, 8, 9].map((key) => {
            return (
              <div key={key} style={{ padding: '1rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <IonSkeletonText animated style={{ width: '60%' }} />
                  <IonSkeletonText animated style={{ width: '20%' }} />
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <IonSkeletonText animated style={{ width: '30%' }} />
                  <IonSkeletonText animated style={{ width: '20%' }} />
                </div>
              </div>
            );
          }) : ''}
        <IonGrid>
          {data.dataSet.map((item: any, key) => {
            return (
              <IonCard id="card-container" key={key}>
                <IonCardHeader>
                  <IonCardTitle className="card-heading">
                    <div className="flex justify-between items-center">
                      <Link className="underline-none" to={{ pathname: '/view-project', state: item.name }}>
                        <span>{item.project_name}</span>
                      </Link>
                    </div>
                  </IonCardTitle>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '0.5rem' }}>
                      {item.status === 'Open' ? <img src={Red} alt="Red" style={{ marginRight: '5px' }} />
                        : <div style={{ marginRight: '5px', height: '0.64rem', width: '0.64rem', backgroundColor: 'green', borderRadius: '999px' }}></div>}
                      <span>{t(`Project.Status.${item.status}`)}</span>
                    </div>
                    {item.location && <span style={{ display: 'flex', alignItems: 'center' }}> <IonIcon style={{ marginLeft: '2px' }} src={location} />{item.location}</span>}
                  </div>
                  <div style={{ display: 'flex' }}>
                    {item.expected_start_date && <p style={{ marginRight: '5px' }}> Start: {item.expected_start_date} |   </p>}
                    {item.expected_end_date && <p> End: {item.expected_end_date}</p>}
                  </div>
                </IonCardHeader>
              </IonCard>
            );
          })}
          <IonInfiniteScroll onIonInfinite={(e: CustomEvent<void>) => searchNext(e)}>
            <IonInfiniteScrollContent
              loadingSpinner="bubbles"
              loadingText="Loading more data..."
            ></IonInfiniteScrollContent>
          </IonInfiniteScroll>
          {!isLoading && data.dataSet.length === 0 ? (
            <IonRow style={{ margin: 'auto', display: 'block' }}>
              <NoRecords width="60%" smallText={false} />
            </IonRow>
          ) : null}
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default ViewAllProjects;
